import { getParsedWordProcessorValue } from "components/word-processor-field/word-processor-value.utils";

/**
 * Whether a scribe's custom-context value is effectively empty (no text).
 *
 * NOTE: This intentionally lives here, NOT in `features/medical-scribe/utils.ts`.
 * That util is imported by the Comlink audio Web Workers
 * (`save-audio-worker`, `upload-audio-worker`), whose bundle has no DOM globals.
 * `getParsedWordProcessorValue` pulls in the word-processor chain (TinyMCE +
 * file-saver), and file-saver references `HTMLAnchorElement` at module-eval —
 * which throws `HTMLAnchorElement is not defined` the moment the worker loads
 * (ENG-1463). Keep word-processor-dependent helpers out of worker-shared modules.
 */
export function isCustomContextEmpty(value?: string | null): boolean {
  return getParsedWordProcessorValue(value ?? "").isTextEmpty;
}
